// The data folders that hold one file per player, named by canonKey: units/ (every unit a
// player fielded, tools/buildUnitHistory.mjs) and bets/ (every bet a player placed,
// tools/buildBetHistory.mjs). Each file carries its own key as `k`.
// ops/publish.mjs uploads every folder in this list as f/<dir>/<playerFile(k)>.<hash>.json
// with a {canonKey: hash} index at <dir>/index.json, and guard.mjs, pullData, serveData and
// dataStore.playerFileFor() all read the same list, so a new folder is one entry here.
export const PLAYER_DIRS = ['units', 'bets'];

// The file a canonKey is stored under. Twitch handles are [a-z0-9_], so this is almost
// always the key itself; anything else is hex-escaped so the name is filesystem-safe and
// two keys can't collide.
export const playerFile = (key) => key.replace(/[^a-z0-9_]/g, (c) => '-' + c.codePointAt(0).toString(16) + '-');
